export const DASHBOARD_PATH = '/';
export const LOGIN_PATH = '/login';
export const USERS_PATH = '/users';
export const DEVICES_PATH = '/devices';
export const ACTIVITY_LOG_PATH = '/activity-log';
export const EMERGENCY_ALERT_PATH = '/emergency-alert';
export const EMERGENCY_ALERT_CREATE_PATH = '/emergency-alert/create';
export const ALERT_LOG_PATH = '/alert-log';
export const TAG_MANAGEMENT_PATH = '/tags';
export const CREATE_ORG_PATH = '/createOrg';
export const SETTINGS_PATH = '/settings';
export const MOBILE_HOME_PATH = '/mobileHome';
export const DEVICE_LOGIN_PATH = '/deviceLogin';
export const USER_RESTRICTED_PERMISSION_PATH = '/userRestriction';
